import Vue from 'vue';
import router from './router';
import { createPinia, PiniaVuePlugin } from 'pinia';
import i18n from './locales/i18n';

/* ant design systems */
import Antd from 'ant-design-vue';
import { message } from 'ant-design-vue';

/* app components */
import DefaultLayout from './layouts/Default.vue';
import DashboardLayout from './layouts/Dashboard.vue';
import DashboardWithoutSidebarLayout from './layouts/DashboardWithoutSidebarLayout.vue';
import LiveCommunicationsLayout from './layouts/LiveCommunicationsLayout.vue';
import App from './App.vue';

import VueNativeNotification from 'vue-native-notification';
Vue.use(VueNativeNotification, {
    // Automatic permission request before
    // showing notification (default: true)
    requestOnNotify: true
})

/* stylesheets */
import 'ant-design-vue/dist/antd.css';
import './scss/app.scss';


Vue.config.productionTip = false;

import { loadLocaleMessages } from './locales/i18n';
loadLocaleMessages();

/* plugin registrations */
Vue.use(PiniaVuePlugin);


Vue.use(Antd);
message.config({
    top: window.innerHeight / 3 + 'px',
    duration: 5,
    maxCount: 5,
});
Vue.prototype.$message = message;

/* global components -- mainly layouts */
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-without-sidebar", DashboardWithoutSidebarLayout);
Vue.component("layout-live-communications", LiveCommunicationsLayout);

const pinia = createPinia();

new Vue({
    router,
    pinia,
    i18n,
    render: h => h(App)
}).$mount('#app');